/**
 *
 */

// Deps
import { selectStyles } from "~/styleguide/forms";
import { createComponent } from "react-fela";

// Components
import MultiSelect from "~/components/shared/form/multi-select";

export default function TypeFilter({ options, handleTypeChange, selected }) {
    // Can't filter by options if there are none
    if (!options || !options.length) return null;

    return (
        <Container>
            <p style={{ fontSize: "14px", marginBottom: "12px" }}>
                Filter by content type
            </p>

            <MultiSelect
                options={options}
                onChange={handleTypeChange}
                selected={selected}
                type="Type"
            />
        </Container>
    );
}

const Container = createComponent(() => ({
    ...selectStyles
}));
